import { getProjectSpecialStatusAPI, loadProjectTableAPI } from "./api";

const initState = {
  pageRoute: {},
  pageList: [],
  workFlowStatus: true,
  loading: false,
  hasPermission: true,
};

let state = {
  ...initState,
  rootId: "",
  userList: [],
  projectRootInfo: {},
  projectDirectors: [],
  pageOne: {},
};

const getInfo = ({ columnInfo, rowInfo, arr }) => {
  const { ids } = columnInfo,
    { cells } = rowInfo;
  const list = arr
    .map((i) => {
      const index = ids.indexOf(i);
      return cells[index].ids;
    })
    .reduce((prev, cur) => prev + ";" + cur);
  return list;
};

const mutations = {
  SET_PAGEROUTE: (state, data) => {
    state.pageRoute = data;
  },

  SET_PERMISSION: (state, data) => {
    state.hasPermission = data;
  },
  CLEAR: () => {
    state = { ...initState };
  },
  SET_PROECT_ROOT(state, data) {
    const { userList } = data;
    state.userList = [...userList];
    state.projectRootInfo = { ...data };
  },
  SET_PROJECT_INFO(state, data) {
    const { columnInfo, rows, creater } = data;
    const [rowInfo] = rows;

    const arr = [1051010, 1051011];
    const list = getInfo({ columnInfo, rowInfo, arr });
    console.log("vuex getInfo list ", { list, creater });

    state.projectDirectors = list.split(";").map((i) => +i);
    state.projectDirectors.push(creater);
    state.pageOne = { columnInfo, rows };
  },
};

const actions = {
  async getWorkFlowStatus({ commit }, param) {
    const { id, baseId } = param;
    const res = await getWorkflowByQualityIdAPI({ qualityId: id });
    const val = res.data.object.workflowStatus.statusType;
    let status = true;
    if (baseId == 401 || baseId == 104) {
      status = ![3, 4].includes(val);
    }
    commit("GET_WORK_FLOW_STATUS", status);
  },

  async getData({ commit }, param) {
    const { id, classId, subClassId } = param;
    const { data } = await loadProjectTableAPI({
      id,
      classId,
      subClassId,
      tableId: 1,
    });
    console.log("load project data", data);
    const { rootId, table, userList } = data.object;
    const { createdBy: creater, tableWritable, columnInfo, rows } = table;

    commit("SET_PROECT_ROOT", { rootId, userList, creater, tableWritable });
    commit("SET_PROJECT_INFO", { columnInfo, rows, creater, rootId });
  },
  clear({ commit }) {
    commit("CLEAR");
  },
};
const getters = {
  getProjectDirectors(state) {
    return state.projectDirectors;
  },
  getPageOne(state) {
    return state.pageOne;
  },
  getProjectRootId(state) {
    return state.projectRootInfo.rootId;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
